export default "__VITE_ASSET___iATXTk1__"